// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".cover[data-v-3954bad4]{-o-object-fit:cover;object-fit:cover}.fill[data-v-3954bad4]{-o-object-fit:fill;object-fit:fill}.contain[data-v-3954bad4]{-o-object-fit:contain;object-fit:contain}.none[data-v-3954bad4]{-o-object-fit:none;object-fit:none}.scale-down[data-v-3954bad4]{-o-object-fit:scale-down;object-fit:scale-down}.avatar-image[data-v-3954bad4]{max-height:425px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
